import React from 'react';
import { colors } from './BlendingColors';
import ColorsGrid from './ColorsGrid';

const ExpandedPallete: React.FC = () => (
  <ColorsGrid colors={colors} isExpanded={true} />
);

export default ExpandedPallete;
